import OSS from 'ali-oss'

// /**
//  * 获取配置
//  * @param region shanghai beijing
//  * @returns {{region: string, accessKeyId: string, accessKeySecret: string, bucket: string}}
//  */
const accessKeySecret = process.env.VUE_APP_ALIYUN_ACCESS_KEY_SECRET
const accessKeyId = process.env.VUE_APP_ALIYUN_ACCESS_KEY_ID
const node_env = process.env.NODE_ENV

/**
 * 根据环境获取oss配置
 * @param env
 * @returns {{region: string, accessKeyId: string, accessKeySecret: string, bucket: string}}
 */
function getOptionsByEnv(env) {
  switch (env) {
    // 公共桶
    case "public":
      return {
        region: 'oss-cn-shanghai',
        accessKeyId,
        accessKeySecret,
        bucket: ['development', 'test'].indexOf(node_env) > -1 ? "health-test-public-yz" : 'health-pro-public-yz'
      }
    // 私有桶
    case "private":
      return {
        region: 'oss-cn-shanghai',
        accessKeyId,
        accessKeySecret,
        bucket: ['development', 'test'].indexOf(node_env) > -1 ? "health-test-private-yz" : 'health-pro-private-yz'
      }
    default:
      return {
        region: 'oss-cn-beijing', accessKeyId, accessKeySecret, // bucket: 'health-test-yz'
        bucket: 'mall-test-yz'
      }
  }
}

/**
 *  获取Oss
 *  @param env
 * @returns {oss}
 */
export function createClient(env = "private") {
  const ossOptions = getOptionsByEnv(env)
  const resultOptions = {
    // 访问凭证从环境变量 VUE_APP_ALIYUN_ACCESS_KEY_ID / VUE_APP_ALIYUN_ACCESS_KEY_SECRET 中读取（配置于 .env.local）
    accessKeyId: ossOptions.accessKeyId, accessKeySecret: ossOptions.accessKeySecret, // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
    region: ossOptions.region, authorizationV4: true, // yourBucketName填写Bucket名称。
    bucket: ossOptions.bucket, secure: true
  }
  return new OSS(resultOptions)
}

export function getSrc(client, src) {
  client = client || createClient()
  if (!src) return ''
  return client.signatureUrl(src, { expires: 999999999999999 }) // 可访问的链接
}
